// menu js

document.addEventListener("DOMContentLoaded", function () {
  // Select the element with both classes
  const modalElement = document.querySelector(
    ".modal--active.modal__container"
  );

  // Check if the element exists
  if (modalElement) {
    // Set a timeout to remove the 'modal--active' class after 2 seconds
    setTimeout(function () {
      modalElement.classList.remove("modal--active");
      
    }, 2000); // 2000 milliseconds = 2 seconds
  }
});

// pop up cart js

 function initializeSliders() {
    // Destroy the sliders if they already exist to avoid multiple initializations
    if ($('.header-slider').hasClass('slick-initialized')) {
      $('.header-slider').slick('unslick');
    }
    if ($('.slider-cstm').hasClass('slick-initialized')) {
      $('.slider-cstm').slick('unslick');
    }
    
    // Initialize the sliders
    $('.header-slider').slick({
      dots: false,
      infinite: true,
      loop: true,
      arrows: false,
      autoplaySpeed: 4500,
      autoplay: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-cstm'
    });

    $('.slider-cstm').slick({
      dots: false,
      infinite: true,
      loop: true,
      arrows: false,
      autoplaySpeed: 4500,
      autoplay: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.header-slider'
    });
  }

  // Initialize sliders on page load
  initializeSliders();

  // Reinitialize sliders on window resize
  $(window).resize(function() {
    initializeSliders();
  });

// Mobile Product Slider
     $('.slider-for').slick({
   slidesToShow: 1,
   arrows: false,
  centerMode: true,
  centerPadding: '60px',
 });


document.addEventListener("DOMContentLoaded", function () {
  var titles = document.querySelectorAll(".footer-sect .section-title");

  titles.forEach(function (title) {
    title.addEventListener("click", function () {
      var isActive = this.classList.contains("active");

      // Close all other accordions
      titles.forEach(function (t) {
        t.classList.remove("active");
        var content = t.nextElementSibling;
        if (content) {
          content.classList.remove("active");
        }
      });

      if (!isActive) {
        // Open the clicked accordion
        this.classList.add("active");
        var content = this.nextElementSibling;
        if (content) {
          content.classList.add("active");
        }
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".shipping-accor-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const panel = this.nextElementSibling;

      // Check if the panel is currently displayed
      const isPanelVisible = panel.style.display === "block";

      // Hide all panels and remove 'active' class from all btn-wrapper elements
      document.querySelectorAll(".shipping-accor-panel").forEach((p) => {
        p.style.display = "none";
      });
      document.querySelectorAll(".btn-wrapper").forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

      if (!isPanelVisible) {
        // If the panel was not visible, show it and add 'active' class to the btn-wrapper
        panel.style.display = "block";
        this.parentElement.classList.add("active");
      }
    });
  });
});

// menu js
console.clear();

const navExpand = [].slice.call(document.querySelectorAll(".fas-nav-expand"));
const backLink = `<li class="fas-nav-item fas-fixed-back">
	<a class="fas-nav-link fas-nav-back-link" href="javascript:;">
  <span class="fas-back-menu">Back</span>
<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org//svg">
<path d="M6.67793 12.7469C6.57598 12.9156 6.41426 13 6.19277 13C6.09082 13 5.96426 12.9789 5.91152 12.9508C5.79551 12.8875 0.0931641 7.17813 0.0369141 7.06914C-0.0123047 6.9707 -0.0123047 6.6543 0.0369141 6.55586C0.0931641 6.44688 5.79551 0.7375 5.91152 0.674219C5.96426 0.646094 6.09082 0.625 6.19277 0.625C6.53379 0.625 6.74824 0.839454 6.74824 1.18047C6.74824 1.28242 6.73066 1.40195 6.70957 1.44414C6.68848 1.48633 5.48262 2.71328 4.02715 4.16523L1.38691 6.8125L4.02715 9.45625C5.48262 10.9117 6.68848 12.1387 6.70957 12.1809C6.77285 12.3074 6.75527 12.6168 6.67793 12.7469Z" fill="black"/>
</svg>

	</a>
</li>`;

navExpand.forEach((item) => {
  item
    .querySelector(".fas-nav-expand-content")
    .insertAdjacentHTML("afterbegin", backLink);
  item
    .querySelector(".fas-nav-link")
    .addEventListener("click", () => item.classList.add("active"));
  item
    .querySelector(".fas-nav-back-link")
    .addEventListener("click", () => item.classList.remove("active"));
});

// Function to remove the class
function removeClassAfterDelay(modal) {
  setTimeout(function () {
    if (modal.classList.contains("modal--active")) {
      modal.classList.remove("modal--active");
    }
  }, 3000); // 3000 milliseconds = 3 seconds
}

// Function to handle the mutation
function handleMutations(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      const modal = document.querySelector("#modal-ajax-cart");
      if (modal && modal.classList.contains("modal--active")) {
        removeClassAfterDelay(modal);
      }
    }
  }
}

// Set up the MutationObserver
const observer = new MutationObserver(handleMutations);

// Target the document body and observe class attribute changes
observer.observe(document.body, { attributes: true, subtree: true });

// featured collection load more button

 document.addEventListener("DOMContentLoaded", function () {
      var loadMoreButton = document.getElementById("load-more-button");
      var hiddenProducts = document.getElementById("hidden-products");
      let showall = document.getElementById("viewallbtn");

      if (loadMoreButton && hiddenProducts && showall) {
        // Add event listener for the button
        loadMoreButton.addEventListener("click", function () {
          hiddenProducts.style.display = "grid";
          loadMoreButton.style.display = "none";
          showall.style.display = "block";
        });
      }
    });

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   var flkty = new Flickity(".carousel", {
//     cellAlign: "left",
//     contain: true,
//     draggable: false, // Disable dragging
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    var carouselElement = document.querySelector(".carousel");

    if (carouselElement) {
      var flkty = new Flickity(carouselElement, {
        cellAlign: "left",
        contain: true,
        draggable: false, // Disable dragging
      });
    } else {
      console.log("Carousel element not found.");
    }
  }, 100); // Adjust the delay as needed
});


document.addEventListener("DOMContentLoaded", function () {
  // Get references to the elements
  const fltrttl = document.getElementById("fltrttl");
  const closeFilter = document.getElementById("close-filter");
  const colsidebr = document.getElementById("sidebar")
  const collectionMainWrapper = document.querySelector(
    ".collection-main-wrapper"
  );
  const body = document.body;

  // Function to toggle the 'active' class on the 'collection-main-wrapper' element and 'body'
  function toggleActive() {
    if (collectionMainWrapper) {
      collectionMainWrapper.classList.toggle("active");
    }
    body.classList.toggle("active");
    colsidebr.classList.toggle("open");
  }

  // Add event listener to the element with ID 'fltrttl'
  if (fltrttl) {
    fltrttl.addEventListener("click", toggleActive);
  }

  // Add event listener to the element with ID 'close-filter'
  if (closeFilter) {
    closeFilter.addEventListener("click", toggleActive);
  }
});

//Add and remove active class from filter headings

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    // Check if the clicked element is a header
    const header = event.target.closest('.collection__sidebar-block .h4');
    if (header) {
      // Find the closest '.collection__sidebar-block' and toggle the '.fltrhead' class
      const ul = header.closest('.collection__sidebar-block').querySelector('.fltrhead');
      if (ul) {
        ul.classList.toggle('active');
      }
      // Prevent click event from bubbling up further
      event.stopPropagation();
    }
  });
});


//End Add and remove active class from filter headings


document.addEventListener("DOMContentLoaded", function () {
  // Get references to the elements
  const toolbarFirst = document.querySelector(".toolbar_first");
  const toolbarSecond = document.querySelector(".toolbar_second");
  const toolbarThird = document.querySelector(".toolbar_third");
  const mainCollectionProductGrid = document.getElementById("CollectionProductGrid");
  
  // Function to handle toolbar clicks
  function handleToolbarClick(clickedToolbar) {
    if (mainCollectionProductGrid) {
      // Remove all grid classes initially
      mainCollectionProductGrid.classList.remove("grid-three", "grid-four");
      
      // Handle active states and class addition
      if (clickedToolbar === toolbarFirst) {
        mainCollectionProductGrid.classList.add("grid-three");
        toolbarFirst.classList.add("active");
        toolbarSecond.classList.remove("active");
        toolbarThird.classList.remove("active");

      } else if (clickedToolbar === toolbarSecond) {
        mainCollectionProductGrid.classList.remove("grid-three");
        mainCollectionProductGrid.classList.remove("grid-four");
        toolbarFirst.classList.remove("active");
        toolbarSecond.classList.add("active");
        toolbarThird.classList.remove("active");

      } else if (clickedToolbar === toolbarThird) {
        mainCollectionProductGrid.classList.add("grid-four");
        toolbarFirst.classList.remove("active");
        toolbarSecond.classList.remove("active");
        toolbarThird.classList.add("active");

      }
    }
  }

  // Event listeners for toolbar items
  if (toolbarFirst) {
    toolbarFirst.addEventListener("click", function () {
      handleToolbarClick(toolbarFirst);
    });
  }
  if (toolbarSecond) {
    toolbarSecond.addEventListener("click", function () {
      handleToolbarClick(toolbarSecond);
    });
  }
  if (toolbarThird) {
    toolbarThird.addEventListener("click", function () {
      handleToolbarClick(toolbarThird);
    });
  }
});

 // window.onload = function() {
 //            if (window.innerWidth <= 980) {
 //                const gridElement =document.getElementById("CollectionProductGrid");
 //                if (gridElement) {
 //                    gridElement.classList.add('grid-three');
 //                  document.querySelector(".toolbar_first").classList.add('active');
 //                  document.querySelector(".toolbar_second").classList.remove('active');
 //                }
 //            }
 //        };


window.addEventListener("scroll", function () {
  var scrollY = window.scrollY;
  var scrollIndicator = document.getElementById("scrollIndicator");

  if (scrollY > 150) {
    document.body.classList.add("scrolled");

  } else {
    document.body.classList.remove("scrolled");

  }
});


 document.addEventListener('DOMContentLoaded', function () {
   setTimeout(function(){
  function updateListingImage(imageUrl, productId) {
    console.log("Updating image for product:", productId, "with URL:", imageUrl); // Debugging log
    var productCard = document.querySelector('#product-listing-' + productId);
    if (productCard) {
      var mainImage = productCard.querySelector('.prod-image .box-ratio img');
      if (mainImage) {
        mainImage.src = imageUrl + '?v=' + new Date().getTime(); // Add timestamp to force reload
        mainImage.srcset = imageUrl + '?v=' + new Date().getTime();
        console.log("Image updated successfully"); // Debugging log
      } else {
        console.log("Main image not found"); // Debugging log
      }
    } else {
      console.log("Product card not found"); // Debugging log
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('li[data-variant-id]');
    if (target) {
      var imageUrl = target.getAttribute('data-image-url');
      var productId = target.closest('.item.product-index').getAttribute('data-product-id');
      console.log("Clicked swatch with image URL:", imageUrl, "and Product ID:", productId); // Debugging log
      if (imageUrl && productId) {
        updateListingImage(imageUrl, productId);
      } else {
        console.log("Image URL or Product ID is missing"); // Debugging log
      }
    }
  });


document.querySelectorAll('.swatches__form--input').forEach(input => {
  input.addEventListener('change', function() {
    const selectedImage = this.getAttribute('data-image');

    // Check if selectedImage is not null or empty
    if (selectedImage) {
      const sliderImages = document.querySelectorAll('.mobprodslider .slick-center img');

      sliderImages.forEach(img => {
        img.src = selectedImage;
        img.setAttribute('srcset', selectedImage);
      });
    }
  });
});
   }, 100);
});



// swatch code start
$(document).ready(function() {
    // Color swatch click event
    $('body').on('click', '.color-swatch li', function() {
        $(this).parents('.item').find('.color-swatch li').removeClass('active');
        $(this).addClass('active');
        console.log(this);
        var Color_name = $(this).attr('data-color').trim().toLowerCase();
        var Color_Id = $(this).attr('data-variant-id');

        $(this).parents('.item').find('.quickAdd--Item.color [name="id"]').val(Color_Id);
        var $forms = $(this).parents('.item').find('form.quickAdd--Item');
        $forms.each(function() {
            var All_var = $(this).attr('data-size').toLowerCase(); 
            if (All_var.includes(Color_name)) {
                $(this).show();  
            } else {
                $(this).hide();  
            }
        });
    });

    // Size swatch click event
    $('body').on('click', '.size-swatch', function() {
        $(this).parents('.item').find('.size-swatch').removeClass('active');
        $(this).addClass('active');
    });

    // On document load, set the active size based on the selected color
    $('.item').each(function() {
        var $activeColor = $(this).find('.color-swatch li.active');
        if ($activeColor.length) {
            var Color_name = $activeColor.attr('data-color').trim().toLowerCase();
            var $forms = $(this).find('form.quickAdd--Item');
            $forms.each(function() {
                var All_var = $(this).attr('data-size').toLowerCase(); 
                if (All_var.includes(Color_name)) {
                    $(this).show();  
                } else {
                    $(this).hide();  
                }
            });
        }

        // Set the active size swatch on load
        var $activeSize = $(this).find('.size-swatch.active');
        if ($activeSize.length) {
            $activeSize.trigger('click');
        }
    });
});

// swatch code end






$(document).ready(function() {
    function initializeProductGridBehavior() {
        // Event delegation for quick add buttons
        $('body').on('click', '.qabtn', function(event) {
            event.stopPropagation(); // Prevent the click from reaching the document

            // Hide all other product grids
            $('.product--grid_add.show').removeClass('show');

            var parentItem = $(this).closest('.product-index');
            if (!parentItem.length) return;

            var productGridAdd = parentItem.find('.product--grid_add');
            if (!productGridAdd.length) return;

            // Toggle the 'show' class on the clicked product grid
            productGridAdd.toggleClass('show');

            // Add class to the body when a .qabtn is clicked
            $('body').addClass('product-grid-open');
           // new code
                var $activeColor = $(this).parents('.item').find('.color-swatch li.active');
                if ($activeColor.length) {
                    var Color_name = $activeColor.attr('data-color').trim().toLowerCase();
                    var $forms = $(this).parents('.item').find('form.quickAdd--Item.size');
                    $forms.each(function() {
                        var All_var = $(this).attr('data-size').toLowerCase(); 
                        if (All_var.includes(Color_name)) {
                            $(this).show();  
                        } else {
                            $(this).hide();  
                        }
                    });
                }
        
                // Set the active size swatch on load
                var $activeSize = $(this).find('.size-swatch.active');
                if ($activeSize.length) {
                    $activeSize.trigger('click');
                }


      // new code
          
        });

        // Event delegation for close buttons
        $('body').on('click', '.clsit', function(event) {
            event.stopPropagation(); // Prevent the click from reaching the document

            var parentItem = $(this).closest('.product-index');
            if (!parentItem.length) return;

            var productGridAdd = parentItem.find('.product--grid_add');
            if (!productGridAdd.length) return;

            // Remove the 'show' class from the clicked product grid
            productGridAdd.removeClass('show');

            // Remove class from the body when a .clsit is clicked
            $('body').removeClass('product-grid-open');
             
        });

        // Click outside handler using jQuery
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.product--grid_add.show, .qabtn, .clsit').length) {
                $('.product--grid_add.show').removeClass('show');
                $('body').removeClass('product-grid-open');
            }
        });

  
    }

    // Initialize on page load
    initializeProductGridBehavior();

    // Initialize when load-more-products button is clicked
    $('#load-more-products').on('click', function() {
        // Allow some time for the new content to be loaded
        setTimeout(initializeProductGridBehavior, 2000); // Adjust the timeout as needed
    });
});





// setTimeout(function(){
//   $('body').on('change', 'input[type="radio"][name="id"]', function() {
//         var selectedVariantId = this.value;

//         // Find the corresponding Buy It Now button
//         var addToCartButton = $('#add-to-cart-' + selectedVariantId);
//         console.log('Buy It Now Button:', addToCartButton);

//         // Trigger a click event on the Buy It Now button
//         if (addToCartButton.length) {
//             addToCartButton.click();
//         } else {
//             console.log('No Buy It Now button found for variant ID:', selectedVariantId);
//         }

//         // Change the label of the selected radio button to "loading..."
//         var label = $('label[for="' + this.id + '"]');
//         if (label.length) {
//             // Store the original text and width
//             var originalText = label.text();
//             var originalWidth = label.outerWidth();
        
//             // Change the label text to "loading..." and update its width
//             label.html('<span class="dot-flashing"></span>');
//             label.css('width', originalWidth);
        
//             // Revert the label text and width after 2 seconds
//             setTimeout(function() {
//                 label.text(originalText);
//                 label.css('width', ''); // Reset to original width (if set in CSS) or allow natural width
//             }, 2000);
//         } else {
//             console.log('No label found for radio button with ID:', this.id);
//         }
//     });
// }, 1000);


function myFunctionaa() {
      	if (navigator.share) {
      		navigator.share({
      			title: '{{ product.title }}',
      			text: "Check this out " + window.location.href
      		}).then(() => {
      			console.log('Thanks for sharing!');
      		}).catch(err => {
      			// Handle errors, if occured
      			console.log(
      			"Error while using Web share API:");
      			console.log(err);
      		});
      	} else {
      		alert("Browser doesn't support, try another browser!");
      	}
      }



// Different class for different browsers
     (function() {
    var userAgent = navigator.userAgent.toLowerCase();
    var body = document.body;

    if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg') === -1 && userAgent.indexOf('opr') === -1) {
        body.classList.add('chrome');
    } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
        body.classList.add('safari');
    } else if (userAgent.indexOf('firefox') > -1) {
        body.classList.add('firefox');
    } else if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
        body.classList.add('ie');
    } else if (userAgent.indexOf('edg') > -1) {
        body.classList.add('edge');
    } else if (userAgent.indexOf('opr') > -1) {
        body.classList.add('opera');
    } else {
        body.classList.add('unknown-browser');
    }
})();
// Different class for different browsers end


// Size Chart Popup
// document.addEventListener('DOMContentLoaded', function () {
//     var sizeChartButton = document.getElementById('sizechartbtn');
//     var sizeChartCont = document.getElementById('sizechartcont');
//     var body = document.body;
//     var clsb = document.getElementById('clspop');
//     var appendedDiv = null;

//     clsb.addEventListener('click', function () {
//         sizeChartCont.style.display = 'none';
//         body.classList.remove('sizechartpopactive'); 
//       document.body.removeChild(appendedDiv);
//                 appendedDiv = null;
//     });

//     sizeChartButton.addEventListener('click', function () {
//         // Toggle the display of the size chart modal
//         if (sizeChartCont.style.display === 'none' || sizeChartCont.style.display === '') {
//             sizeChartCont.style.display = 'block';
//             body.classList.add('sizechartpopactive');
            
//             // Toggle the appended div
//             if (!appendedDiv) {
//                 // Create and append the div if it doesn't exist
//                 appendedDiv = document.createElement('div');
//                 appendedDiv.id = 'appendedDiv';
//                 document.body.appendChild(appendedDiv);
//             } else {
//                 // Remove the div if it already exists
//                 document.body.removeChild(appendedDiv);
//                 appendedDiv = null;
//             }
//         } else {
//             sizeChartCont.style.display = 'none';
//             body.classList.remove('sizechartpopactive');
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
    var sizeChartButton = document.getElementById('sizechartbtn');
    var sizeChartCont = document.getElementById('sizechartcont');
    var body = document.body;
    var clsb = document.getElementById('clspop');
    var appendedDiv = null;

    console.log(sizeChartButton, sizeChartCont, clsb); // Debugging

    if (sizeChartButton && sizeChartCont && clsb) {
        clsb.addEventListener('click', function () {
            sizeChartCont.style.display = 'none';
            body.classList.remove('sizechartpopactive');
            if (appendedDiv) {
                document.body.removeChild(appendedDiv);
                appendedDiv = null;
            }
        });

        sizeChartButton.addEventListener('click', function () {
            if (sizeChartCont.style.display === 'none' || sizeChartCont.style.display === '') {
                sizeChartCont.style.display = 'block';
                body.classList.add('sizechartpopactive');

                if (!appendedDiv) {
                    appendedDiv = document.createElement('div');
                    appendedDiv.id = 'appendedDiv';
                    document.body.appendChild(appendedDiv);
                } else {
                    document.body.removeChild(appendedDiv);
                    appendedDiv = null;
                }
            } else {
                sizeChartCont.style.display = 'none';
                body.classList.remove('sizechartpopactive');
            }
        });
    } else {
        console.log('One or more elements are not found.');
    }
});

// Size Chart Popup End


// Placeholder Div
 document.addEventListener('DOMContentLoaded', function() {
            var placeholderDiv = document.querySelector('.placeholderdiv');
            if (placeholderDiv) {
                placeholderDiv.style.display = 'none';
            }
        });

// Placeholder Div End




      (function() {
    var userAgent = navigator.userAgent.toLowerCase();
    var body = document.body;

    if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg') === -1 && userAgent.indexOf('opr') === -1) {
        body.classList.add('chrome');
    } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
        body.classList.add('safari');
    } else if (userAgent.indexOf('firefox') > -1) {
        body.classList.add('firefox');
    } else if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
        body.classList.add('ie');
    } else if (userAgent.indexOf('edg') > -1) {
        body.classList.add('edge');
    } else if (userAgent.indexOf('opr') > -1) {
        body.classList.add('opera');
    } else {
        body.classList.add('unknown-browser');
    }
})();

$( ".slideout__trigger--open").mouseover(function()
        {
            $(".custom-cart").addClass("Hover-modal--active");

        });
 
 $( ".slideout__trigger--open" ).mouseout(function()
        {
             $(".custom-cart").removeClass("Hover-modal--active");

        });



// sidebar scroll
document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const productContent = document.querySelector('.collection__page--productContent');

    if (!productContent) return;

    function checkVisibility() {
        const rect = productContent.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Add class when element is at the top of the viewport
        if (rect.top < viewportHeight && rect.bottom > 0) {
            body.classList.add('your-custom-class');
        } else {
            body.classList.remove('your-custom-class');
        }

        // Remove class when element is out of view from the bottom
        if (rect.bottom < 300 || rect.top > viewportHeight) {
            body.classList.remove('your-custom-class');
        }
    }

    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility); // Adjust for resizing window
    checkVisibility(); // Initial check on load
});
// sidebar scroll

$(document).ready(function() {
    // Get the current URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const sorbyvalu = urlParams.get('sort_by');
    
    // Check if the sort_by parameter exists
    if (sorbyvalu) {
        // Find the corresponding <li> element based on the value
        $(".js-hz-filter-list li input").each(function() {
            if ($(this).val() === sorbyvalu) {
                // Get the data-placeholder from the parent <li>
                const newPlaceholder = $(this).closest('li').data('placeholder');
                
                // Update the input placeholder
                $('#HZ-Sortby').attr('placeholder', newPlaceholder);
            }
        });
    }
    
    // Click event for updating the URL
    $(".js-hz-filter-list li").on("click", function() {
        var sorbyvalu = $(this).children("input").val();
        var currenturl = window.location.pathname;  
        window.location.replace("https://vibenests.shop" + currenturl + "?sort_by=" + sorbyvalu);
    });
});


setTimeout(function () {

  $(".docapp-coupon-input--button-text").on("click", function(){
setTimeout(function () {
    location.reload(); 
},3000) 
  }) },2000);


$("#Cart_trigger_btn").on("touchstart",function(){
window.location.replace("https://vibenests.shop/cart");
});

$("#Cart_trigger_btn").mouseover(function(){
  $(".slideout__trigger--open .drawar_cart_custom").trigger("click");
});
